export default __webpack_public_path__ + "static/media/recentTx.406a2eba.svg";